// extracted by mini-css-extract-plugin
export default {"footerLinkItem":"Footer_footerLinkItem__+TP+G","footerBox":"Footer_footerBox__mh9XR","footerLinks":"Footer_footerLinks__NKkj1","footerCopyRight":"Footer_footerCopyRight__su50x"};